module.exports = __webpack_public_path__ + "img/14.1ff4bc3b.gif";